import { VFC } from 'react';
import { Badge, Button, Dropdown } from 'antd';
import { EllipsisOutlined } from '@ant-design/icons';
import { useStore as useInventorizeStore } from 'routes/inventorize_meter/useStore';
import { useStore as useInstallStore } from 'routes/installation/useStore';
import { InventoryMenu } from 'components/Layout/components/InventoryMenu';
import { useReplaceMeterStore } from 'routes/meter_replacement/useStore';
import { useSessionStore } from '../../../../store/session';

export const MenuButton: VFC = () => {
  const { isAuthenticated } = useSessionStore();
  const { queuedMetersCount: queuedPasportMetersCount, isSendingData: isSendingPasportData } = useInventorizeStore();
  const { queuedMetersCount: queuedInstallMetersCount, isSendingData: isSendingInstalledData } = useInstallStore();
  const { queuedMetersCount: queuedReplaceMetersCount, isSendingData: isSendingReplaceMetersData } =
    useReplaceMeterStore();

  const isLoading = isSendingPasportData || isSendingInstalledData || isSendingReplaceMetersData;
  const showDot =
    isAuthenticated && (!!queuedPasportMetersCount || !!queuedInstallMetersCount || !!queuedReplaceMetersCount);

  return (
    <Badge dot={showDot}>
      <Dropdown overlay={<InventoryMenu />} placement="bottomRight" trigger={['click']}>
        <Button icon={<EllipsisOutlined spin={isLoading} />} loading={isLoading} size="middle" type="primary" />
      </Dropdown>
    </Badge>
  );
};
